module.exports = __webpack_public_path__ + "img/arrow-left-active.1216cb5d.svg";